import { Inject, Singleton } from '@denishussar/html5-game-engine';
import { ModalsNames } from '../Common/MadalsManager/ModalsList';
import { GameModel, GameStateEnum } from '../Models/GameModel';
import { GameLogic } from './GameLogic';

/**
 * Represents the logic of top panel
 */
@Singleton
export class TopPanelLogic {

    constructor(
        @Inject private _model: GameModel,
        @Inject private _gameLogic: GameLogic,
    ) {

    }

    public handleClickOnLivesIndicator() {
        this._gameLogic.modalsManager.show(ModalsNames.shopLives);
        //this._gameLogic.setState(GameStateEnum.shopLife);
    }

    public handleClickOnCoinsIndicator() {
        this._gameLogic.modalsManager.show(ModalsNames.shop);
    }

    public handleClickOnExitButton() {
        switch (this._model.gameState) {
            case GameStateEnum.game:
                this._gameLogic.setState(GameStateEnum.main);
                break;
        }
        this._gameLogic.setState(GameStateEnum.main);
    }
}
